module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/create_template_plus-2abdf0aeec7d66b05eea3dd21cc9a7dc.svg";